import { ReauthorizationCrecaApi } from "@/features/accounts/creca/services/reauthorization-api";
import { ReauthorizationCrecaRequestModel } from "@/features/accounts/creca/services/reauthorization-model";

/// クレカサイト認可画面要求(再認可)処理
export class ReauthorizationCrecaService {
  private reauthorizationCrecaApi = new ReauthorizationCrecaApi();
  /**
   * クレカサイト認可画面要求(再認可)API実行
   */
  public async reauthorizeCreca(param: ReauthorizationCrecaRequestModel) {
    return await this.reauthorizationCrecaApi.reauthorizeCreca(param);
  }
}
